import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
    withStyles,
    ListItem,
    ListItemText,
    ListItemIcon,
    IconButton,
    Grid,
    Typography,
    Button,
    List,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import CancelPresentation from '@material-ui/icons/CancelPresentation';

import { updateDetailSettings } from 'Console/data/applicationDetail/settings/SettingsAction';

import {
    selectApplicationJourneyTracker,
    selectEnabledJourneys,
    selectDisabledJourneys,
} from 'Console/data/applicationDetail/settings/SettingsSelector';

import FormSelect from 'Console/components/common/form/FormSelect';

import { getValueFromLocalizedObject } from 'Console/utils/languageUtils';
import { selectContentLanguageCode } from 'Console/data/language/selectors';

const styles = (theme) => ({
    root: {
        boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.25)',
    },
    column: {
        flexBasis: '45%',
    },
    btnAdd: {
        marginTop: theme.spacing.unit + 7,
        marginLeft: theme.spacing.unit * 5 + 7,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    listItems: {
        paddingTop: theme.typography.pxToRem(20),
        paddingBottom: theme.typography.pxToRem(20),
    },
    listItem: {
        padding: 0,
    },
    listItemIcon: {
        margin: 0,
    },
    boxList: {
        width: '100%',
        maxWidth: '960px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    itemsBox: {
        width: '100%',
    },
    details: {
        paddingTop: theme.typography.pxToRem(24),
    },
});

class JourneysExpansionPanel extends Component {
    // eslint-disable-next-line
    state = {
        isExpanded: false,
    };

    handleRemoveItem = (journeyToRemove) => () => {
        const { journeyTracker } = this.props;

        const updatedJourneyTracker = {};

        Object.keys(journeyTracker).forEach((key) => {
            const journey = journeyTracker[key];
            if (journey.content.id === journeyToRemove.content.id) {
                updatedJourneyTracker[key] = {
                    ...journey,
                    enabledInContextHelp: false,
                    order: 0,
                };
                return;
            }

            updatedJourneyTracker[key] = {
                ...journey,
                order: journey.order > journeyToRemove.order ? journey.order - 1 : journey.order,
            };
        });

        this.updateJourneyTracker(updatedJourneyTracker);
    };

    handleAddItem = () => {
        const {
            form: { getFieldValue, setFieldsValue },
            journeyTracker,
        } = this.props;
        const selectedJourney = getFieldValue('selectJourney');

        setFieldsValue({
            selectJourney: '',
        });

        const updatedJourneyTracker = {};

        Object.keys(journeyTracker).forEach((key) => {
            const journey = journeyTracker[key];
            if (journey.content.id === selectedJourney.id) {
                updatedJourneyTracker[key] = {
                    ...journey,
                    enabledInContextHelp: true,
                    order: 0,
                };
                return;
            }

            updatedJourneyTracker[key] = {
                ...journey,
                order: journey.enabledInContextHelp ? journey.order + 1 : 0,
            };
        });

        this.updateJourneyTracker(updatedJourneyTracker);
    };

    handleChangeOrder = (changedJourney, value) => () => {
        const { journeyTracker, enabledJourneys } = this.props;
        const changedJourneyOrder = changedJourney.order;
        const updatedJourneyTracker = {};

        // Increase first journey
        if (changedJourney.order + 1 === enabledJourneys.length && value === 1) {
            return;
        }

        // Decrease last journey
        if (changedJourney.order === 0 && value === -1) {
            return;
        }

        Object.keys(journeyTracker).forEach((key) => {
            const journey = journeyTracker[key];

            if (journey.content.id === changedJourney.content.id) {
                updatedJourneyTracker[key] = {
                    ...journey,
                    order: changedJourney.order + value,
                };
                return;
            }

            // Increase
            if (value === 1 && journey.order === changedJourneyOrder + 1) {
                updatedJourneyTracker[key] = {
                    ...journey,
                    order: journey.order - 1,
                };
                return;
            }

            // Decrease
            if (value === -1 && journey.order === changedJourneyOrder - 1) {
                updatedJourneyTracker[key] = {
                    ...journey,
                    order: journey.order + 1,
                };

                return;
            }

            updatedJourneyTracker[key] = {
                ...journey,
            };
        });

        this.updateJourneyTracker(updatedJourneyTracker);
    };

    onExpand = () => {
        const { isExpanded } = this.state;
        this.setState({
            isExpanded: !isExpanded,
        });
    };

    sortJourneysByOrder = (journeys) =>
        journeys.sort((a, b) => {
            const nameA = a.order;
            const nameB = b.order;
            if (nameA < nameB) {
                return 1;
            }
            if (nameA > nameB) {
                return -1;
            }
            return 0;
        });

    updateJourneyTracker = (updatedJourneyTracker) => {
        const { updateDetailSettings, intl } = this.props;

        updateDetailSettings(
            {
                [`metadata.journeyTracker`]: updatedJourneyTracker,
            },
            {
                success: `${intl.formatMessage({ id: 'Notification.update.journey.success' })}`,
                fail: `${intl.formatMessage({ id: 'Notification.update.journey.fail' })}`,
            }
        );
    };

    render() {
        const {
            intl,
            classes,
            journeyTracker,
            form,
            contentLanguageCode,
            disabledJourneys,
            enabledJourneys,
        } = this.props;

        const { isExpanded } = this.state;

        if (!journeyTracker) {
            return null;
        }

        const sortedEnabledJourneys = this.sortJourneysByOrder(enabledJourneys);

        return (
            <ExpansionPanel expanded={isExpanded} onChange={this.onExpand}>
                <ExpansionPanelSummary className={classes.root} expandIcon={<ExpandMoreIcon />}>
                    <div className={classes.column}>
                        <Typography variant="subtitle1">
                            {intl.formatMessage({ id: 'ContextHelp.expansionPanel.journeys' })}
                        </Typography>
                    </div>
                </ExpansionPanelSummary>

                <ExpansionPanelDetails className={classes.details}>
                    <Grid item xs={12}>
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            className={classes.itemsBox}
                        >
                            <Grid style={{ width: '20.5625rem' }}>
                                <FormSelect
                                    form={form}
                                    fullWidth
                                    isRequired
                                    formItemKey="selectJourney"
                                    label={intl.formatMessage({ id: 'ContextHelp.journey.placeholder' })}
                                    disabledJourneys
                                    optionList={disabledJourneys.map((journey) => ({
                                        id: journey.content.id,
                                        name: getValueFromLocalizedObject(
                                            journey.content.name,
                                            contentLanguageCode
                                        ),
                                    }))}
                                />
                            </Grid>

                            <Typography>
                                <Button
                                    id="yeself-button"
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleAddItem}
                                    className={classes.btnAdd}
                                >
                                    {intl.formatMessage({ id: 'Buttons.add' })}
                                </Button>
                            </Typography>
                        </Grid>

                        <Grid item className={classes.boxList}>
                            <List className={classes.listItems}>
                                {sortedEnabledJourneys.map((item) => (
                                    <ListItem className={classes.listItem} key={item.content.id}>
                                        <ListItemText
                                            primary={getValueFromLocalizedObject(
                                                item.content.name,
                                                contentLanguageCode
                                            )}
                                            primaryTypographyProps={{
                                                style: {
                                                    textWrap: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                },
                                            }}
                                        />

                                        <ListItemIcon className={classes.listItemIcon}>
                                            <IconButton
                                                aria-label="ArrowUpward"
                                                onClick={this.handleChangeOrder(item, 1)}
                                            >
                                                <ArrowUpward />
                                            </IconButton>
                                        </ListItemIcon>

                                        <ListItemIcon className={classes.listItemIcon}>
                                            <IconButton
                                                aria-label="ArrowDownward"
                                                onClick={this.handleChangeOrder(item, -1)}
                                            >
                                                <ArrowDownward />
                                            </IconButton>
                                        </ListItemIcon>

                                        <ListItemIcon className={classes.listItemIcon}>
                                            <IconButton
                                                aria-label="Delete"
                                                onClick={this.handleRemoveItem(item)}
                                            >
                                                <CancelPresentation />
                                            </IconButton>
                                        </ListItemIcon>
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>
                    </Grid>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    }
}

export default connect(
    (state) => ({
        journeyTracker: selectApplicationJourneyTracker(state),
        enabledJourneys: selectEnabledJourneys(state),
        disabledJourneys: selectDisabledJourneys(state),
        contentLanguageCode: selectContentLanguageCode(state),
    }),
    { updateDetailSettings }
)(withStyles(styles)(injectIntl(JourneysExpansionPanel)));
